var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"field",attrs:{"label":_vm.label,"value":_vm.valueString,"rules":_vm.rules,"prefix":_vm.prefix,"suffix":_vm.suffix,"disabled":_vm.disabled},on:{"change":function($event){_vm.$emit('change', _vm.makeNumber($event))}}})}
var staticRenderFns = []

export { render, staticRenderFns }